// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3eFcu","info":"Note_info__2K-Ma","note":"Note_note__iNbYT","actions":"Note_actions__1ONLY"};